// src/redux/actions.js

import * as types from './actionTypes'; // Import all action types as 'types'
import apiService from '../apiService';

export const fetchPrograms = () => {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PROGRAMS_REQUEST }); // Dispatch request action

    try {
      const programs = await apiService.get('/program'); // Make GET request via apiService
      // console.log("programs", programs);
      dispatch({
        type: types.FETCH_PROGRAMS_SUCCESS,
        payload: programs,
      });
      return programs; // Return programs directly
    } catch (error) {
      dispatch({
        type: types.FETCH_PROGRAMS_FAILURE,
        error: 'Failed to fetch programs',
      });
      throw error; // Throw error to be caught in component
    }
  };
};

// Fetch specific program details
export const fetchProgramDetails = (id) => {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PROGRAM_DETAILS_REQUEST }); // Dispatch request action

    try {
      const programDetails = await apiService.get(`/program/${id}`); // Make GET request for specific program
      dispatch({
        type: types.FETCH_PROGRAM_DETAILS_SUCCESS,
        payload: programDetails,
      });
      return programDetails; // Return program details directly
    } catch (error) {
      dispatch({
        type: types.FETCH_PROGRAM_DETAILS_FAILURE,
        error: `Failed to fetch program details for ID ${id}`,
      });
      throw error; // Throw error to be caught in component
    }
  };
};
